import { Component, OnDestroy, OnInit, inject } from '@angular/core';
import { APPLICATION_ROUTES } from '../../../constants/application-routes';
import { ContentUtil } from '../../../utils/content/content.util';
import { Content } from 'src/common/interfaces/content.interface';

import { content } from '../../../../content/zci/content';
import { AdobePageName } from '../../../services/adobe-launch/adobe-launch.pages';
import { AdobeLaunchService } from '../../../services/adobe-launch/adobe-launch.service';
import { VgnService } from '../../../services/vgn/vgn.service';
import { PageComponent } from '../page.component';
import { RouterLink } from '@angular/router';
import { IconModule } from '@vg-constellation/angular-20/icon';

@Component({
    selector: 'zci-unsuccessful-attempt-page',
    templateUrl: './unsuccessful-attempt-page.component.html',
    imports: [
        IconModule,
        RouterLink,
    ],
})
export class UnsuccessfulAttemptPageComponent extends PageComponent implements OnInit, OnDestroy {
    private readonly vgnService = inject(VgnService);
    private adobeLaunchService = inject(AdobeLaunchService);


    content: Content = ContentUtil.content || content;

    appRoutes = APPLICATION_ROUTES;

    ngOnInit(): void {
        this.vgnService.setMinimalNav(true);
        this.adobeLaunchService.pageLoad(AdobePageName.UNSUCCESSFUL_ATTEMPT_PAGE);
    }

    ngOnDestroy(): void {
        this.vgnService.setMinimalNav(false);
    }
}
